/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { useHistory, Link } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_UPLOADS, API_SERVER } from '../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Module]
-------------------------------------------------------------------*/
import LinesEllipsis from 'react-lines-ellipsis'
import { decode } from "html-entities";
import Fade from 'react-reveal/Fade';
import Slider from "react-slick";

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
/*------------------------------------------------------------------
[End React Module]
-------------------------------------------------------------------*/

const settings = {
	lazyLoad: true,
	autoplay : true,
	autoplaySpeed : 5000,
	dots: false,
	infinite: true,
	speed: 500,
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: true
};

const Screen = ({ads, about, bulletin, contact, profile_personal, services, testimonial, gallery, video, images, event, article, news}) => {

	const createMarkup = () => {
        return {__html: JSON.parse(decode(about[0].entry))}
    }

/*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    history.push('/simpr/home')
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/

	return (
		<div className="__content">

			{/* <div className="_container">
				<div className="_lily_pad_h_d">
					<div className="_heading_italic">
						Book Web Series 1
					</div>
					<div className="_heading_bold">
						Nodejs Programming Book : <span className="_grey">Direct Login & CRUD with Nodejs, Expressjs, MYSQL, API, Reactjs, Security</span>
					</div>
				</div>
			</div> */}

			<div className="_container">
				<div className="_push_t_g">
					<div className="_lily_pad_h_d _push_b_g">
						<div className="_row" style={{alignItems: 'center'}}>
							<div className="_column">
							<Fade top cascade>
								<h1>Sambutan</h1>
							</Fade>
							</div>
							<div className="_column _right_text">
								<Fade top cascade>
									<Link 
										to={{
											pathname: "/pages/" + about[0].slug,
											hash: "#about",
										}}   
										className="_btn __cl_bg_main _cl_coco_000 _border_none" 
										style={{borderRadius: 32}}	
									>
										Selengkapnya
									</Link>
								</Fade>
							</div>
						</div>
					</div>
					<Fade top cascade>

						<div className="__about _row_auto">
							<div className="_column_auto">
								<img src={about[0].preview} style={{borderRadius: 8}} />
							</div>
							<div className="_column_auto_2">
								<div className="_push_t_t">
									<small>Publised, {about[0].date}</small>
								</div>
								<LinesEllipsis
									style={{marginTop: 6}}
									text={decode(about[0].title)}
									maxLine='2'
									ellipsis='...'
									trimRight
									basedOn='letters'
								/>
								{/* <div className="_push_t_d _font_size_18px">
									{decode(about[0].description)}
								</div> */}
								<div className="__entry _about_section _push_t_m" dangerouslySetInnerHTML={createMarkup()}></div>
							</div>
						</div>
						
					</Fade>
				</div>
			</div>

			<div className="__news_container">
				<div className="_container">
					<div className="_push_t_g _push_b_g">
						<div className="_lily_pad_h_d _push_b_g">
							<div className="_row" style={{alignItems: 'center'}}>
								<div className="_column">
									<Fade top cascade>
										<h1>Berita</h1>
									</Fade>
								</div>
								<div className="_column _right_text">
									<Fade top cascade>
										<Link to="/news" 
											className="_btn __cl_bg_main _cl_coco_000 _border_none" 
											style={{borderRadius: 32}}	
										>
											Selengkapnya
										</Link>
									</Fade>
								</div>
							</div>
						</div>
						<Fade top cascade>
										
							<div className="_row_sync">
								{
									news ?
										news.map((item, index) => (
											<Link 
												key={index}
												to={{
													pathname: 'post/' + item.slug,
												}} 
												className="_column_sync"
											>
												<div className="__card" style={{backgroundImage: `url(${item.preview})`}}>

												</div>
												<div className="_push_t_m">
													<div className="_row _center_align">
														<div className="_push_r_s">
															<ion-icon name="time-outline" style={{fontSize: 18, marginBottom: -4}}></ion-icon>
														</div>
														<div className="_column">
															<small>Publised, {item.date}</small>
														</div>
													</div>
												</div>
												<LinesEllipsis
													style={{marginTop: 6}}
													text={decode(item.title)}
													maxLine='2'
													ellipsis='...'
													trimRight
													basedOn='letters'
												/>
											</Link>
										))
									: 
										new Array(4).fill(undefined).map((index) => (
											<div key={index} className="_column_sync">
												<div className="__card"/>
											</div>
										))
								}
							</div>
						
						</Fade>
					</div>
				</div>
			</div>		
			
			<div className="_container">
				<div className="_push_t_g">
					<div className="_lily_pad_h_d _push_b_g">
						<div className="_row" style={{alignItems: 'center'}}>
							<div className="_column">
							<Fade top cascade>
								<h1>Kegiatan</h1>
							</Fade>
							</div>
							<div className="_column _right_text">
								<Fade top cascade>
									<Link to="/event" 
										className="_btn __cl_bg_main _cl_coco_000 _border_none" 
										style={{borderRadius: 32}}	
									>
										Selengkapnya
									</Link>
								</Fade>
							</div>
						</div>
					</div>
					<Fade top cascade>

						<div className="_row_sync">
							{
								event ? 
									event.map((item, index) => (
										<Link 
											key={index}
											to={{
												pathname: 'post/' + item.slug,
											}} 
											className="_column_sync"
										>
											<div className="__card" style={{backgroundImage: `url(${item.preview})`}}>

											</div>
											<div className="_push_t_m">
												<div className="_row _center_align">
													<div className="_push_r_s">
														<ion-icon name="time-outline" style={{fontSize: 18, marginBottom: -4}}></ion-icon>
													</div>
													<div className="_column">
														<small>Publised, {item.date}</small>
													</div>
												</div>
											</div>
											<LinesEllipsis
												style={{marginTop: 6}}
												text={decode(item.title)}
												maxLine='2'
												ellipsis='...'
												trimRight
												basedOn='letters'
											/>
										</Link>
									))
								:
									new Array(4).fill(undefined).map((index) => (
										<div key={index} className="_column_sync">
											<div className="__card"/>
										</div>
									))
							}
						</div>
						
					</Fade>
				</div>
			</div>

			<div className="__section_long_contact _overflow_hidden">
				<div className="_container _relative">
					<div style={{position: 'absolute', top: -50, left: -250}}>
						<ion-icon name="airplane-outline" style={{fontSize: 300, color: '#f1f1f1'}}></ion-icon>
					</div>
					<div className="_row _center_align" style={{paddingLeft: 20, paddingRight: 20}}>
						<div className="_column">
							<Fade top cascade>
								<p className="_font_size_50px"><span style={{color: '#000'}}>Hubungi</span> <span className="__cl_text_second">Kami</span></p>
							</Fade>
						</div>
						<div className="_column _right_text">
							<Fade top cascade>
								<Link
									to={{
										pathname: '/pages/' + contact[0].slug,
									}}  
									className="_btn __cl_bg_main _cl_coco_000 _border_none" 
									style={{borderRadius: 32}}	
								>
									Kontak
								</Link>
							</Fade>
						</div>
					</div>
				</div>
			</div>

			{/* <div className="_container">
				<div className="_push_t_g _push_b_g">
					<div className="_lily_pad_h_d _push_b_g">
						<div className="_row" style={{alignItems: 'center'}}>
							<div className="_column">
								<Fade top cascade>
									<h1>Gallery</h1>
								</Fade>
							</div>
							<div className="_column _right_text">
								<Fade top cascade>
									<Link to="/gallery" 
										className="_btn __cl_bg_main _cl_coco_000 _border_none" 
										style={{borderRadius: 32}}	
									>
										Selengkapnya
									</Link>
								</Fade>
							</div>
						</div>
					</div>
					<Fade top cascade>		
						<div className="_row_sync">
							{
								gallery ?
									gallery.map((item, index) => (
										<Link 
											key={index}
											to={{
												pathname: API_UPLOADS + item.media,
											}} 
											target="_blank"
											className="_column_sync"
										>
											<div className="__card" style={{backgroundImage: `url(${API_UPLOADS + item.media})`}}>

											</div>
										</Link>
									))
								: 
									new Array(4).fill(undefined).map((index) => (
										<div key={index} className="_column_sync">
											<div className="__card"/>
										</div>
									))
							}
						</div>
					</Fade>
				</div>
			</div> */}

			<div className="_container">
				<div className="_push_t_g _push_b_g">
					<div className="_lily_pad_h_d _push_b_g">
						<div className="_row" style={{alignItems: 'center'}}>
							<div className="_column">
								<Fade top cascade>
									<h1>Anggota</h1>
								</Fade>
							</div>
							<div className="_column _right_text">
								<Fade top cascade>
									<Link to="/profile" 
										className="_btn __cl_bg_main _cl_coco_000 _border_none" 
										style={{borderRadius: 32}}	
									>
										Selengkapnya
									</Link>
								</Fade>
							</div>
						</div>
					</div>
					<Fade top cascade>
									
						<div className="_row_sync">
							{
								profile_personal ?
									profile_personal.map((item, index) => (
										<Link 
											key={index}
											to={{
												pathname: API_UPLOADS + item.image,
											}} 
											target="_blank"
											className="_column_sync"
										>
											<div className="__card" style={{height: 280,backgroundImage: `url(${API_UPLOADS + item.image})`}}>

											</div>
											<div className="_row _center_align _push_b_t">
												<div className="_push_r_s" style={{marginBottom: -14}}>
													<ion-icon name="ribbon-outline" style={{fontSize: 20}}></ion-icon>
												</div>
												<div className="_column">
													<LinesEllipsis
														style={{marginTop: 12, fontSize: 18}}
														text={decode(item.title)}
														maxLine='2'
														ellipsis='...'
														trimRight
														basedOn='letters'
													/>
												</div>
											</div>
											<div className="_row _center_align">
												<div className="_column">
													<LinesEllipsis
														style={{marginTop: 0, color: '#888'}}
														text={decode(item.description)}
														maxLine='2'
														ellipsis='...'
														trimRight
														basedOn='letters'
													/>
												</div>
											</div>
											
										</Link>
									))
								: 
									new Array(4).fill(undefined).map((index) => (
										<div key={index} className="_column_sync">
											<div className="__card"/>
										</div>
									))
							}
						</div>
					
					</Fade>
				</div>
			</div>

			<div style={{marginTop: 70, marginBottom: 70}}>
				<div className="_relative">
					{
						images ?
							<>
								<img style={{width: '100%'}} lazyLoad src={API_UPLOADS + images[0].image}/>
								<div className="_relative _container">
									<div style={{position: 'absolute', bottom: 20, right: 20}}>
										<Fade top cascade>
											<Link to="/images" 
												className="_btn __cl_bg_main _cl_coco_000 _border_none" 
												style={{borderRadius: 32}}	
											>
												Selengkapnya
											</Link>
										</Fade>
									</div>
								</div>
							</>
						: 
							new Array(4).fill(undefined).map((index) => (
								<div key={index} className="_column_sync">
									<div className="__card"/>
								</div>
							))
					}
				</div>
			</div>

			<div className="_container">
				<div className="_push_t_g _push_b_g">
					<div className="_lily_pad_h_d _push_b_g">
						<div className="_row" style={{alignItems: 'center'}}>
							<div className="_column">
								<Fade top cascade>
									<h1>Fasilitas</h1>
								</Fade>
							</div>
							<div className="_column _right_text">
								<Fade top cascade>
									<Link to="/services" 
										className="_btn __cl_bg_main _cl_coco_000 _border_none" 
										style={{borderRadius: 32}}	
									>
										Selengkapnya
									</Link>
								</Fade>
							</div>
						</div>
					</div>
					<Fade top cascade>
									
						<div className="_row_sync">
							{
								services ?
									services.map((item, index) => (
										<Link 
											key={index}
											to={{
												pathname: API_UPLOADS + item.image,
											}} 
											target="_blank"
											className="_column_sync"
										>
											<div className="__card" style={{height: 230,backgroundImage: `url(${API_UPLOADS + item.image})`}}>

											</div>
											<div className="_row _center_align _push_b_t">
												<div className="_push_r_s" style={{marginBottom: -14}}>
													{/* <ion-icon name="happy-outline" style={{fontSize: 20}}></ion-icon> */}
													<ion-icon name={decode(item.icon)} style={{fontSize: 20}}></ion-icon>
												</div>
												<div className="_column">
													<LinesEllipsis
														style={{marginTop: 12, fontSize: 18}}
														text={decode(item.title)}
														maxLine='2'
														ellipsis='...'
														trimRight
														basedOn='letters'
													/>
												</div>
											</div>
											<LinesEllipsis
												style={{marginTop: 0, color: '#888'}}
												text={decode(item.description)}
												maxLine='2'
												ellipsis='...'
												trimRight
												basedOn='letters'
											/>
										</Link>
									))
								: 
									new Array(4).fill(undefined).map((index) => (
										<div key={index} className="_column_sync">
											<div className="__card"/>
										</div>
									))
							}
						</div>
					
					</Fade>
				</div>
			</div>

			<div className="_container">
				<div className="_push_t_g _push_b_g">
					<div className="_lily_pad_h_d _push_b_g">
						<div className="_row" style={{alignItems: 'center'}}>
							<div className="_column">
								<Fade top cascade>
									<h1>Testimonial</h1>
								</Fade>
							</div>
							<div className="_column _right_text">
								<Fade top cascade>
									<Link to="/testimonial" 
										className="_btn __cl_bg_main _cl_coco_000 _border_none" 
										style={{borderRadius: 32}}	
									>
										Selengkapnya
									</Link>
								</Fade>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div className="__testimonial_container">
				<div className="__slick_container">
					<div className="_container _relative">
						<div style={{position: 'absolute', top: 0, left: -270}}>
							<ion-icon name="balloon-outline" style={{fontSize: 300, color: '#f1f1f1'}}></ion-icon>
						</div>
					</div>
					<Slider {...settings}>
						{
							testimonial ?
								testimonial.map((item, index) => (
									<div key={index} className="_relative">
										<div className="__testimonial_header">
											<div className="_container">
												<div className="_row_auto">
													<div className="_column_auto_2 _left_text">
														<div>
															<Fade top cascade>
																<p className="_font_size_30px" style={{color: '#222'}}>{item.title}</p>
															</Fade>

															<Fade top cascade>
																<p style={{maxWidth: 650, fontSize: 18}}>{item.description}</p>
															</Fade>
														</div>
													</div>
													<div className="_column_auto _right_text">
														<div className="__testimonial_profile"  style={{backgroundImage: `url(${API_UPLOADS + item.image})`}}>

														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								))
							:
								new Array(4).fill(undefined).map((index) => (
									<div key={index} className="_column_sync">
										<div className="__card"/>
									</div>
								))
						}
					</Slider>
				</div>
			</div>
			

			<div className="_container">
				<div className="_push_t_g _push_b_g">
					<div className="_lily_pad_h_d _push_b_g">
						<div className="_row" style={{alignItems: 'center'}}>
							<div className="_column">
								<Fade top cascade>
									<h1>Video</h1>
								</Fade>
							</div>
							<div className="_column _right_text">
								<Fade top cascade>
									<Link to="/video" 
										className="_btn __cl_bg_main _cl_coco_000 _border_none" 
										style={{borderRadius: 32}}	
									>
										Selengkapnya
									</Link>
								</Fade>
							</div>
						</div>
					</div>
					<Fade top cascade>
									
						<div className="_row_auto">
							{
								video ?
									video.map((item, index) => (
										<div
											className="_column_auto"
										>
											<div className="_iframe_responsive">
												<iframe
													style={{borderRadius: 8}}
													src={item.video}>
												</iframe>
											</div>
											<LinesEllipsis
												style={{marginTop: 12, fontSize: 18}}
												text={decode(item.title)}
												maxLine='2'
												ellipsis='...'
												trimRight
												basedOn='letters'
											/>
											<LinesEllipsis
												style={{marginTop: 0, color: '#888'}}
												text={decode(item.description)}
												maxLine='2'
												ellipsis='...'
												trimRight
												basedOn='letters'
											/>
										</div>
									))
								: 
									new Array(4).fill(undefined).map((index) => (
										<div key={index} className="_column_sync">
											<div className="__card"/>
										</div>
									))
							}
						</div>
					
					</Fade>
				</div>
			</div>

			<div className="__section_count _overflow_hidden">
				<div className="_container _relative">
					<div style={{position: 'absolute', top: -100, left: -280}}>
						<ion-icon name="magnet-outline" style={{fontSize: 300, color: '#f1f1f1'}}></ion-icon>
					</div>
					<div className="_row_sync" style={{marginLeft: -70, marginRight: -70}}>
						<div className="_column_sync">
							<div className="_center_text">
								<Fade top cascade>
									<h1 className="__cl_text_main">{bulletin.length}+</h1>
								</Fade>
								<Fade top cascade>
									<p className="_font_size_18px">Pengumuman</p>
								</Fade>
							</div>
						</div>
						<div className="_column_sync">
							<div className="_center_text">
								<Fade top cascade>
									<h1 className="__cl_text_main">{news.length}+</h1>
								</Fade>
								<Fade top cascade>
									<p className="_font_size_18px">Berita</p>
								</Fade>
							</div>
						</div>
						<div className="_column_sync">
							<div className="_center_text">
								<Fade top cascade>
									<h1 className="__cl_text_main">{event.length}+</h1>
								</Fade>
								<Fade top cascade>
									<p className="_font_size_18px">Kegiatan</p>
								</Fade>
							</div>
						</div>
						<div className="_column_sync">
							<div className="_center_text">
								<Fade top cascade>
									<h1 className="__cl_text_main">{article.length}+</h1>
								</Fade>
								<Fade top cascade>
									<p className="_font_size_18px">Artikel</p>
								</Fade>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="_container">
				<div className="_row_auto">
					<div className="_column_auto_2">
						<div>
							<div className="_row" style={{alignItems: 'center'}}>
								<div className="_column">
									<Fade top cascade>
										<h1>Artikel</h1>
									</Fade>
								</div>
								<div className="_column _right_text">
									<Fade top cascade>
										<Link to="/article" 
											className="_btn __cl_bg_main _cl_coco_000 _border_none" 
											style={{borderRadius: 32}}	
										>
											Selengkapnya
										</Link>
									</Fade>
								</div>
							</div>
							<Fade top cascade>
								<div className="_push_t_d">
									{
										article ? 
											article.map((item, index) => (
												<Link 
													key={index}
													to={{
														pathname: 'post/' + item.slug,
													}} 
													className="_row_auto"
													style={{marginRight: -10, marginLeft: -10}}
												>
													<div className="_column_auto">
														<div className="__card" style={{backgroundImage: `url(${item.preview})`}}>

														</div>
													</div>
													<div className="_column_auto_2">
														<div className="_push_t_t">
															<div className="_row _center_align">
																<div className="_push_r_s">
																	<ion-icon name="time-outline" style={{fontSize: 18, marginBottom: -4}}></ion-icon>
																</div>
																<div className="_column">
																	<small>Publised, {item.date}</small>
																</div>
															</div>
														</div>
														<LinesEllipsis
															style={{marginTop: 6, marginBottom: 6, color: '#444', fontWeight: 700, fontSize: 15}}
															text={decode(item.title)}
															maxLine='2'
															ellipsis='...'
															trimRight
															basedOn='letters'
														/>
														<LinesEllipsis
															style={{marginTop: 6, marginBottom: 6, color: '#666'}}
															text={decode(item.description)}
															maxLine='3'
															ellipsis='...'
															trimRight
															basedOn='letters'
														/>
														<div>
															<small>By {item.author}</small>
														</div>
													</div>
												</Link>
											))
										:
													
											<div className="_row_sync" style={{marginLeft: -10, marginRight: -10}}>
												{
													new Array(4).fill(undefined).map((index) => (
														<div key={index} className="_column_sync">
															<div className="__card"/>
														</div>
													))
												}
											</div>
									}
								</div>
							</Fade>
						</div>
					</div>

					<div className="_column_auto">
						<Fade top cascade>
							<div>
								<div className="_row" style={{alignItems: 'center'}}>
									<div className="_column">
										{
											ads &&
											<Fade top cascade>
												<h1>{ads[0].title}</h1>
											</Fade>
										}
									</div>
								</div>
								<div className="_push_t_d">
									{
										ads &&
										<a href={API_UPLOADS + ads[0].media}>
											<img src={API_UPLOADS + ads[0].media} style={{borderRadius: 8}} />
										</a>
									}
								</div>
							</div>
						</Fade>
					</div>
				</div>
			</div>
		
		</div>
	);
}

export default Screen;